import moment from 'moment';
import { DataSet } from '@facet-wealth/design';

const coneLowSeriesName = 'total-account-balance-all-tolerance-low';
const coneHighSeriesName = 'total-account-balance-all-tolerance-high';
const coneSeries = [coneLowSeriesName, coneHighSeriesName];
const isConeSeries = (seriesName) => coneSeries.includes(seriesName);

const filterOutcomesBySchema = (outcomes, schemaID) => {
  if (!outcomes) {
    return outcomes;
  }
  return outcomes.filter(outcome => !outcome.attributes.dataSchemaId || outcome.attributes.dataSchemaId.includes(schemaID));
};

export const convertChartDataResourceToDataSet = (chartDataResource) => {
  const exportedChartDataResource = chartDataResource.export();

  const dataSeries = exportedChartDataResource.attributes.dataSchema.data.map((schemaResource) => {
    const firstPoint = exportedChartDataResource.attributes?.data?.data[0];
    const firstKey = firstPoint?.attributes?.keys?.data[0];
    const yFormat = firstKey?.attributes?.valueFormat ?? 'usd';
    const xFormat = exportedChartDataResource.attributes.keyFormat ?? 'monthYear';
    // A balance schema's ID will either be "balance" or something like "123_balance" where 123 is the plan's ID when comparing plans
    const isBalanceSeries = /(^|_)balance/.test(schemaResource.id);

    return {
      referenceName: schemaResource.id,
      color: schemaResource.attributes.color,
      name: schemaResource.attributes.label,
      representation: (schemaResource.attributes.presentation === 'bar') ? 'stacked-bar' : schemaResource.attributes.presentation,
      dataPointFormats: [xFormat, yFormat],
      groupName: 'group-1',
      tooltip: schemaResource.attributes.tooltip,
      points: exportedChartDataResource.attributes.data.data.map((dataResource) => {
        const pointResource = dataResource.attributes.keys.data.find((currPointRes) => {
          return currPointRes.id === schemaResource.id;
        });


        // Only show outcomes on the balance series for now
        const canHaveOutcomes = isBalanceSeries;
        const outcomes = canHaveOutcomes ? filterOutcomesBySchema(dataResource.attributes.outcomes?.data, schemaResource.id) : [];
        const hasOutcomes = outcomes.length > 0;

        return {
          x: xFormat === 'usd' ? +dataResource.id : moment(dataResource.id).toDate(),
          y: Number(pointResource.attributes.value),
          meta: {
            emphasized: hasOutcomes,
            hasOutcomes,
            outcomes,
            clients: dataResource.attributes.clients?.data || [],
          },
        };
      }),
    };
  });

  const hasConeSeries = exportedChartDataResource.attributes.dataSchema.data.filter((schemaResource) => {
    return isConeSeries(schemaResource.id);
  }).length === coneSeries.length;

  const dataRanges = (hasConeSeries) ? [{
    referenceName: 'balance-range',
    name: 'Likely Between',
    color: 'primary',
    series: [coneLowSeriesName, coneHighSeriesName],
  }] : undefined;

  return new DataSet({
    series: dataSeries,
    ranges: dataRanges,
  });
};
